import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal, PopupModal } from "../Components";
import { NavLink, useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig"
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md"
import { FaHandHoldingHeart } from "react-icons/fa"
import DataTable from 'react-data-table-component';
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import "./master_categories.css";
import { BiSearch } from "react-icons/bi"
import { NavbarComponent } from "../Components/navbar/NavComponent";
import useDebouncedValue from "../Utils/Debounce";
import { useURLParams } from '../Components/UrlUtils/useURLParams';
import { MarketingNavbarComponent } from "../Components/navbar";


const PromotionalCategory = () => {
    const { setParam, getParam } = useURLParams();
    const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("")
    const [deletePopupType, setDeletepopupType] = useState("")
    const [loading, setLoading] = useState(false)
    const [RowId, SetRowId] = useState()
    let navigate = useNavigate();
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [popupType, setpopupType] = useState("")
    const [message, setMessage] = useState('')
    const [search, SetSearch] = useState({
        search: getParam('search') || ""
    })
    const debouncedSearchTerm = useDebouncedValue(search.search, 500);
    const tableCustomStyles = {
        table: {
            style: {
                backgroundColor: "#fff",
                borderRadius: "18px",
                overflow: "hidden",
                border: "1px solid #e8e8e8",
                margin: "10px 10px"
            },
        },

        headRow: {
            style: {
                minHeight: "68px",
                borderBottom: "1px solid #ececec",
                backgroundColor: "#fff",
            },
        },

        headCells: {
            style: {
                fontSize: "11px",
                fontWeight: "500",
                color: "#6b7280",
                textTransform: "uppercase",
                letterSpacing: "1px",
                fontFamily: "Inter, sans-serif",
                paddingLeft: "18px",
                paddingRight: "18px",
            },
        },

        rows: {
            style: {
                minHeight: "78px",
                borderBottom: "1px solid #f1f1f1",
                fontSize: "13px",
                fontWeight: 500,
                fontFamily: "Inter, sans-serif",
            },
        },

        cells: {
            style: {
                paddingLeft: "18px",
                paddingRight: "18px",
                whiteSpace: "normal",
                lineHeight: "15px",
            },
        },

        pagination: {
            style: {
                borderTop: "1px solid #ececec",
                minHeight: "60px",
            },
        },
    };

    const [selectedCategoryId, setSelectedCategoryId] = useState({
        subcategory: getParam("subcategory") || "",
        category: getParam("category") || "",
    });
    const [Categories, setCategory] = useState([]);
    const categories = async () => {
    };
    const [Subcategories, setSubcategory] = useState([]);
    const subategories = async () => {
    };

    useEffect(() => {
        GetData();
        categories();
        subategories();
    }, [
        currentPage,
        RowPerPage,
        selectedCategoryId.category,
        selectedCategoryId.subcategory,
        selectedCategoryId.category,
        debouncedSearchTerm,
    ]);

    const handleCategoryFilterChange = (selectedOption, name) => {
    };
    const clearSelection = (name) => {
        setSelectedCategoryId({ ...selectedCategoryId, [name]: "" });
        setParam(name, ""); // Reset or remove the URL parameter
    };

    const [Datafilter, SetDatafilter] = useState([]);
    const [Data, SetData] = useState([]);
    const GetData = async () => {
        setLoading(true);
        try {
            const url = `cms/promotional_category/?page=${currentPage}&page_size=${RowPerPage}&ordering=-id&search=${debouncedSearchTerm}`;

            const response = await axiosConfig.get(url);
            SetData(response.data?.results ?? []);
            setTotalRows(response.data?.count ?? 0);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    // const [Products, SetProducts] = useState([]);
    // const GetProducts = async () => {
    //     try {
    //         const url = `cms/products/`;
    //         const response = await axiosConfig.get(url);
    //         SetProducts(response.data?.results ?? []);
    //     }
    //     catch (error) {
    //         console.log(error);
    //         return [];
    //     }

    // };
    // useEffect(() => {
    //     GetProducts();
    // }, []);

    const HandleSearch = (e) => {
        e.preventDefault()
        const name = e.target.name
        const value = e.target.value
        console.log(name, value)
        SetSearch({ ...search, [name]: value })
        setParam('search', value);
    }
    const handleSort = (column, direction) => {
        console.log(column.selector, direction)
        axiosConfig.get(`/cms/promotional_category/?page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.selector : -column.selector}`).then(res => {
            SetData(res.data.results)
        }).catch(error => {
            console.log(error)
        })
        setCurrentPage(1);
    };
    const handleNaigate = () => {
        navigate("/dashboard/masters/promotionalcategory/add")
    }

    const columns = [
        {
            name: "S.No",
            selector: "id",
            cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
        },
        {
            name: "Title",
            grow: 1.5,
            selector: "title",
            cell: (row) => row.title,
            sortable: true,
            reorder: true,
        },
        {
            name: "Slug",
            selector: "slug",
            cell: (row) => row.slug,
            sortable: true,
            reorder: true,
        },

        // {
        //     name: "Products",
        //     grow: 3,
        //     cell: (row) =>
        //         row.products
        //             ?.map(
        //                 (id) => Products.find((p) => p.id === id)?.name
        //             )
        //             .filter(Boolean)
        //             .join(", ") || "loading...",
        //     sortable: true,
        //     reorder: true,
        // },

        // {
        //     name: "Status",
        //     cell: (row) => (row.status_flag ? "Active" : "Inactive"),   
        //     sortable: true,
        //     reorder: true,

        // },
        {
            name: "Actions",
            width: "240px",
            cell: (row) => {
                const HandleEdit = () =>
                    navigate(`/dashboard/masters/promotionalcategoryadd/${row.id}/edit`);
                return (
                    <>
                        {!row.is_suspended ? (
                            <>
                                <div className="table-actions">
                                    <button className="action-btn edit-btn" onClick={HandleEdit}>
                                        <MdOutlineEdit /> Edit
                                    </button>

                                    <button className="action-btn delete-btn" onClick={() => {
                                        SetRowId(row.id);
                                        SetAlertDeletePopupType("success");
                                    }}>
                                        <MdDeleteOutline /> Delete
                                    </button>
                                </div>
                            </>
                        ) : (
                            <FaHandHoldingHeart
                                className="dashboard-tabe-data-actions"
                                onClick={() =>
                                    axiosConfig.post(
                                        `cms/promotional_category/${row.id}/revive/`
                                    ).then(() => {
                                        setpopupType("success")
                                        setMessage("Promotional category Revived Successfully")
                                        GetData()
                                    })
                                }
                            />
                        )}
                    </>
                );
            },
        },
    ];
    const HandleDelete = async () => {
        try {
            await axiosConfig.delete(
                `cms/promotional_category/${RowId}/`
            );
            SetAlertDeletePopupType("error");
            setDeletepopupType("success");
            GetData();
        } catch (error) {
            setDeletepopupType("error");
            SetAlertDeletePopupType("error");
        }
    };

    const CancelAlerrt = () => {
        SetAlertDeletePopupType("error");
    };
    return (
        <>
            <div className="child-sidenav">
                <MarketingNavbarComponent />
                <div className="childnav-content">
                    <div>
                        <div className="button-pro">
                            <div className="cat-button">
                                <div className="btn" onClick={handleNaigate} >
                                    + Add New
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="space-flex">
                                {/* <div className="col-6">
                                    <div className="flex">
                                        {console.log(Categories)}
                                        <div className="product-filter">
                                            <Select options={Categories.map(Categories => ({ value: Categories.id, label: Categories.name }))} placeholder="Select Category" value={Categories && Categories.map(res => ({ "value": res.id, "label": res.name })).find(res => res.value === parseFloat(selectedCategoryId.category))||null} onChange={(selectedOption) => {
                                                if (!selectedOption) {
                                                    clearSelection("category"); 
                                                } else {
                                                    handleCategoryFilterChange(selectedOption,"category");
                                                }
                                            }} isClearable required />
                                        </div>

                                    </div>
                                </div> */}
                                <div className="col-6 input-with-icon">
                                    <span className="icon-product"><BiSearch /></span>
                                    <input type="text" className="input-control" placeholder="Search" name="search" value={search.search} onChange={HandleSearch} />
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive marginTop">
                            <DataTable
                                columns={columns}
                                data={Data} pagination paginationTotalRows={totalRows}
                                paginationPerPage={RowPerPage}
                                paginationDefaultPage={currentPage}
                                onChangePage={(page) => setCurrentPage(page)}
                                paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                                onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                                onSort={handleSort}
                                paginationServer fixedHeader subHeader customStyles={tableCustomStyles} progressPending={loading}
                                progressComponent={<div className="loader-container">
                                    <img src={require('../Components/FormParser/images/loader2.gif')} alt="Loading..." />
                                </div>}
                                subHeaderComponent={
                                    <input type="text" className="form-control w-50" placeholder="Search" name="search" value={search.search} onChange={HandleSearch} />} />
                        </div>
                    </div>
                </div>
            </div>
            {popupType != "" &&
                <PopupModal setpopupType={setpopupType} popupType={popupType} Navigation="/dashboard/masters/promotionalcategory" Message={message} />
            }
            {deletePopupType != "" &&
                <DeletePopupModal setDeletepopupType={setDeletepopupType} deletePopupType={deletePopupType} />
            }
            {
                AlertDeletePopupType === "success" &&
                <AlertDeletePopupModal
                    AlertDeletePopupType={AlertDeletePopupType}
                    HandleDelete={HandleDelete}
                    CancelAlerrt={CancelAlerrt}
                    row={RowId}
                />
            }

            {popupType !== "" &&
                <PopupModal
                    setpopupType={setpopupType}
                    popupType={popupType}
                    Navigation="/dashboard/masters/promotionalcategory"
                    Message={message}
                />
            }

            {deletePopupType !== "" &&
                <DeletePopupModal
                    setDeletepopupType={setDeletepopupType}
                    deletePopupType={deletePopupType}
                />
            }
        </>
    )
}
export default PromotionalCategory;